<template>
    <div class="">
        <div id="scan_action_description_alert">
            <div v-if="is_initialized && current_scan_action_prototype.description_options"
                class="ui segment z-depth-2"
                :style="{
                    background: theme.background,
                    color: theme.color.font,
                    top: (current_scan_action_prototype.description_options.length >= 7) ? '10%' : '20%'
                }">

                <p style="font-size:16px;">
                    <!-- 請填入貨況備註 -->
                    {{ $t('ui.scanner.alerts.please_write_scan_note') }}
                    <span style="color:red;">
                        <!-- [必填] -->
                        [{{ $t('ui.scanner.alerts.required') }}]
                    </span>
                </p>

                <div class="description_options">
                    <div
                        class="ui inverted button"
                        v-for="(description_option, index) in current_scan_action_prototype.description_options"
                        @click="current_store.scan_action_description = description_option"
                        :class="{
                            fluid: is_mobile_width,
                            red: index%7 == 0,
                            orange: index%7 == 1,
                            violet: index%7 == 2,
                            white: index%7 == 3,
                            purple: index%7 == 4,
                            pink: index%7 == 5,
                            active: current_store.scan_action_description == description_option
                        }"
                    >
                        {{ description_option }}
                    </div>

                </div>

                <!-- <div
                    class="ui message"
                    style="padding: 12px;"
                    v-if="current_store.scan_action_description">
                    {{ current_store.scan_action_description }}
                </div> -->

                <!-- <div class="ui fluid input">
                    <input type="text"
                        id="alert_input"
                        autofocus
                        tabindex="-1"
                        autocomplete="off"
                        placeholder="必填欄位"
                        @keypress.enter="next_actions_core_waybill_related()"
                        v-model="current_store.scan_action_description">
                </div> -->

                <div class="right aligned"
                    style="padding-top: 12px;">
                    <button class="ui inverted red button"
                        @click="give_up_scan_action_description()">
                        <!-- 放棄 -->
                        {{ $t('ui.scanner.alerts.give_up') }}
                    </button>
                    <button class="ui inverted blue button"
                        @click="finish_scan_action_description()">
                        <!-- 確定 -->
                        {{ $t('ui.scanner.alerts.definite') }}
                    </button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import FileUploader from "@toolbox/file_uploader/main.vue"
import Keyboard from '@javascripts/keyboard.js'

export default {
    components: {
        FileUploader
    },
    props: {
        is_inverted: {
            default: false,
            type: Boolean
        },
        is_modal_opened: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_initialized: false,
            is_mobile_width: false,
            is_enter_keyboard_to_finish_action: false,
            current_column: {},
            current_column_order: 0,
            file_uploader: {
                status: "",
                message: "",
            },
            core_waybill_receipt_file_url_eventbus: "",
        }
    },
    computed: {
        current_store() {
            return this.$store.state.customer.scanner_module
        },
        style() {
            return this.$store.state.style
        },
        theme() {
            return this.current_store.config.theme
        },
        settings() {
            return this.current_store.settings
        },
        scan_action_description() {
            return this.current_store.scan_action_description
        },
        current_scan_action_prototype() {
            return this.current_store.current_scan_action_prototype
        },
        array_description_options() {
            if (!this.current_store.current_scan_action_prototype.description_options) {
                return []
            }
        },
    },
    watch: {
        is_modal_opened(value) {
            if (value) {
                this.toggle_scanner_is_keydown(false)
                this.init()
            }
        },
        current_core_waybill_need_related_columns() {
            this.init()
        },
    },
    deleted() {
        this.is_enter_keyboard_to_finish_action = false
    },
    mounted() {
        this.is_mobile_width = (this.style.width <= 767)
            ? true
            : false

        $(window).resize(() => {
            this.is_mobile_width = (this.style.width <= 767)
                ? true
                : false
        })

        this.is_enter_keyboard_to_finish_action = true
        $(window).bind("keydown", this.window_keydown)
        this.toggle_scanner_is_keydown(false)
        this.init()
    },
    methods: {
        window_keydown(e) {
            if (this.is_enter_keyboard_to_finish_action) {
                var keyboard = new Keyboard(e)

                if (keyboard.key_code == 13 && !this.current_store.is_keydown) {
                    this.finish_scan_action_description()
                }
            }
        },
        toggle_scanner_is_keydown(boolean = false) {
            this.current_store.is_keydown = boolean
        },
        async init() {
            try {
                await this.focus_input()
                await new Promise(resolve => {
                    this.current_column_order = 0
                    this.is_initialized = true
                    resolve()
                })
            } catch (e) {
                console.log(e)
            }
        },
        focus_input() {
            $(document).ready(() => {
                $("#alert_input").focus()
            })
            return Promise.resolve()
        },
        give_up_scan_action_description() {
            this.current_store.scan_action_description = ""
            var error_content = this.$t('ui.scanner.errors.give_up_scan_action_description')

            this.toggle_scanner_is_keydown(true)
            this.$parent.alert_failure(error_content)
            this.$noty.error(error_content, 1200)
        },
        async finish_scan_action_description() {
            try {
                // 沒填寫
                if (
                    !this.scan_action_description
                ) {
                    // throw "請填寫貨況備註"
                    throw this.$t('ui.scanner.helps.write_scan_action_note')
                }

                this.toggle_scanner_is_keydown(true)
                this.$parent.alert_success()
            } catch (err) {
                this.$noty.error(err, 1200)
            }
        },
    },

}
</script>

<style lang="scss" scoped>
    .center.aligned {
        text-align: center;
    }
    .left.aligned {
        text-align: left;
    }
    .right.aligned {
        text-align: right;
    }

    #scan_action_description_alert {
        & {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            z-index: 2;
            background-color: rgba(27, 28, 29, 0.8);
            overflow-y: auto;
        }
        .segment {
            width: 50%;
            top: 20%;
            margin: 0 auto;
        }
        .description_options .button {
            margin-top: 6px;
            margin-bottom: 6px;
        }
    }


    @media only screen and (max-width: 767px) {
        #scan_action_description_alert {
            .segment {
                width: 100%;
            }
        }
    }

    @media only screen and (min-width: 767px) {

    }
</style>
